import { render, staticRenderFns } from "./ai-model-context.vue?vue&type=template&id=0a32f4d2&scoped=true"
import script from "./ai-model-context.vue?vue&type=script&lang=js"
export * from "./ai-model-context.vue?vue&type=script&lang=js"
import style0 from "./ai-model-context.vue?vue&type=style&index=0&id=0a32f4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a32f4d2",
  null
  
)

export default component.exports